"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDnd = require("react-dnd");

var _CwButton = _interopRequireDefault(require("../../cwbutton/CwButton"));

var _CwImage = _interopRequireDefault(require("../../cwimage/CwImage"));

var _CwTextField = _interopRequireDefault(require("../../cwtextfield/CwTextField"));

var _CwComboBox = _interopRequireDefault(require("../../cwcombobox/CwComboBox"));

var _CwMultiSelect = _interopRequireDefault(require("../../cwmultiselect/CwMultiSelect"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ColumnResizeBar = _interopRequireDefault(require("./ColumnResizeBar"));

var _FileSizeFilter = _interopRequireDefault(require("../filterTypes/FileSizeFilter"));

var _NumberFilter = _interopRequireDefault(require("../filterTypes/NumberFilter"));

var _TimeFilter = _interopRequireDefault(require("../filterTypes/TimeFilter"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

var _ValidationUtils = require("../../../utils/ValidationUtils");
/**
 * specifies how to handle drag and drop events
 */


var dragSource = {
  beginDrag: function beginDrag(props) {
    props.setReorderMode(props.column.key);
    return {
      columnKey: props.column.key
    };
  },
  endDrag: function endDrag(props) {
    props.setReorderMode('');
  }
};
/**
 * Specifies the props to inject into your component.
 */

var collect = function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};

var ColumnHeader =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ColumnHeader, _React$Component);

  function ColumnHeader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ColumnHeader);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ColumnHeader).call(this, props));
    _this.state = {
      lastMultiSelectValue: []
    };
    _this.handleClearFilterClick = _this.handleClearFilterClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSetSort = _this.handleSetSort.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInputChange = _this.handleInputChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMultiSelectChange = _this.handleMultiSelectChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ColumnHeader, [{
    key: "dateFilterValueExists",
    value: function dateFilterValueExists() {
      var returnValue = true;

      if (!this.props.filterValue.startDate.length && !this.props.filterValue.endDate.length) {
        returnValue = false;
      }

      return returnValue;
    }
  }, {
    key: "doesFilterHaveValue",
    value: function doesFilterHaveValue() {
      var returnValue = false;

      switch (this.props.column.filterType) {
        case 'comboBox':
          if (this.props.filterValue) {
            returnValue = true;
          }

          break;

        case 'text':
        case 'multiSelect':
          if (this.props.filterValue.length) {
            returnValue = true;
          }

          break;

        case 'date':
          if (Object.prototype.hasOwnProperty.call(this.props.filterValue, 'startDate') && Object.prototype.hasOwnProperty.call(this.props.filterValue, 'endDate') && (this.props.filterValue.startDate.length || this.props.filterValue.endDate.length)) {
            returnValue = true;
          }

          break;

        case 'fileSize':
          if (Object.prototype.hasOwnProperty.call(this.props.filterValue, 'minFileSize') && Object.prototype.hasOwnProperty.call(this.props.filterValue, 'maxFileSize') && (this.props.filterValue.minFileSize > 0 || this.props.filterValue.maxFileSize > 0)) {
            returnValue = true;
          }

          break;

        case 'number':
          if (Object.prototype.hasOwnProperty.call(this.props.filterValue, 'minValue') && Object.prototype.hasOwnProperty.call(this.props.filterValue, 'maxValue') && (this.props.filterValue.minValue !== null || this.props.filterValue.maxValue !== null)) {
            returnValue = true;
          }

          break;

        case 'time':
          if (Object.prototype.hasOwnProperty.call(this.props.filterValue, 'startTime') && Object.prototype.hasOwnProperty.call(this.props.filterValue, 'endTime') && (this.props.filterValue.startTime !== null || this.props.filterValue.endTime !== null)) {
            returnValue = true;
          }

          break;

        default: // do nothing

      }

      return returnValue;
    }
  }, {
    key: "handleClearFilterClick",
    value: function handleClearFilterClick() {
      switch (this.props.column.filterType) {
        case 'comboBox':
          this.props.onFilterChange(null);
          break;

        case 'text':
          this.props.onFilterChange('');
          break;

        case 'multiSelect':
          this.props.onFilterChange([]);
          break;

        case 'number':
          this.props.onFilterChange({
            minValue: null,
            maxValue: null
          });
          break;

        case 'date':
          this.props.onFilterChange({
            startDate: '',
            endDate: ''
          });
          break;

        case 'fileSize':
          this.props.onFilterChange(_FileSizeFilter.default.getBlankFilterValue());
          break;

        case 'time':
          this.props.onFilterChange(_TimeFilter.default.getBlankFilterValue());
          break;

        default: // do nothing

      }
    }
  }, {
    key: "handleSetSort",
    value: function handleSetSort() {
      if (this.props.column.sortable) {
        this.props.setSortCol(this.props.column.key);
      }
    }
  }, {
    key: "handleMultiSelectChange",
    value: function handleMultiSelectChange(value) {
      var _this2 = this;

      var valueToSet = value.slice();
      var addedValues = value.slice().filter(function (item) {
        return !_this2.state.lastMultiSelectValue.includes(item);
      });

      if (addedValues.length > 1) {
        // select all
        addedValues = addedValues.filter(function (addedValue) {
          var returnValue = false;

          var filterItem = _this2.props.column.filterItems.filter(function (item) {
            return item.id === addedValue;
          })[0];

          if (!filterItem.ignoreSelectAll) {
            returnValue = true;
          }

          return returnValue;
        });
      }

      addedValues.forEach(function (addedValue) {
        var filterItem = _this2.props.column.filterItems.filter(function (item) {
          return item.id === addedValue;
        })[0];

        if (Object.prototype.hasOwnProperty.call(filterItem, 'deselectId')) {
          valueToSet = valueToSet.filter(function (item) {
            return item !== filterItem.deselectId;
          });
        }
      });
      this.setState({
        lastMultiSelectValue: valueToSet.slice()
      });
      this.props.onFilterChange(valueToSet);
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value) {
      var regex = this.props.column.regex || /^[a-zA-Z0-9`~@$^*+\-\][';/.|}{":?\s]+$/;
      var valueCopy = value.slice(0);
      value.split('').forEach(function (_char) {
        if (!(0, _ValidationUtils.matchRegex)(_char, regex, 'g')) {
          valueCopy = valueCopy.replace(_char, '');
        }
      });
      this.props.onFilterChange(valueCopy);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var sortArrow = this.props.sortReverse ? this.props.sortArrowImageReverse : this.props.sortArrowImage;
      var clearFilterButtonRight = 16;
      var buttonBGWidth = 34; // determine isCurrentSortCol

      var isCurrentSortCol = false;

      if (this.props.column.sortable && this.props.column.key === this.props.sortCol) {
        isCurrentSortCol = true;
      } // determine sort direction


      var sortDirectionString = '';

      if (isCurrentSortCol) {
        sortDirectionString = this.props.sortReverse ? 'desc' : 'asc';
      } // overrides for specific filter types


      switch (this.props.column.filterType) {
        case 'comboBox':
        case 'date':
        case 'fileSize':
        case 'number':
        case 'multiSelect':
        case 'time':
          if (this.props.column.triggerIcon && this.props.column.triggerIcon.length > 0) {
            clearFilterButtonRight = 34;
            buttonBGWidth = 52;
          }

          break;

        default: // do nothing

      } // calculate multi select value


      var multiSelectValue = '';

      if (this.props.column.filterType === 'multiSelect') {
        if (this.props.filterValue.length > 1) {
          multiSelectValue = '(multiple)';
        } else if (this.props.filterValue.length === 1) {
          multiSelectValue = this.props.column.filterItems.filter(function (item) {
            return item.id === _this3.props.filterValue[0];
          })[0].name;
        }
      }

      return _react.default.createElement("div", {
        className: _CwDataGrid.default.columnHeader,
        style: {
          width: this.props.column.width
        }
      }, this.props.connectDragSource(_react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_column_").concat(this.props.column.key),
        "data-sort-direction": sortDirectionString,
        tabIndex: "-1",
        className: (0, _classnames.default)(_CwDataGrid.default.columnHeaderLabel, (0, _defineProperty2.default)({}, _CwDataGrid.default.hoverCursor, this.props.column.sortable)),
        onClick: this.handleSetSort,
        title: this.props.column.titleText || ''
      }, _react.default.createElement("div", null, this.props.column.label), isCurrentSortCol && _react.default.createElement(_CwImage.default, {
        className: _CwDataGrid.default.sortArrow,
        src: sortArrow
      }))), Object.prototype.hasOwnProperty.call(this.props.column, 'filterType') && _react.default.createElement("div", {
        className: _CwDataGrid.default.filterContainer
      }, _react.default.createElement("div", {
        className: _CwDataGrid.default.buttonBG,
        style: {
          width: buttonBGWidth
        }
      }), this.doesFilterHaveValue() && _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_column_").concat(this.props.column.key, "_clear_filter"),
        icon: this.props.clearFilterImage,
        className: _CwDataGrid.default.clearFilterButton,
        style: {
          right: clearFilterButtonRight
        },
        onClick: this.handleClearFilterClick
      }), this.props.column.filterType === 'blank' && _react.default.createElement("div", {
        className: _CwDataGrid.default.blankFilter
      }, "\xA0"), this.props.column.filterType === 'text' && _react.default.createElement(_CwTextField.default, {
        cwId: "".concat(this.props.cwId, "_column_").concat(this.props.column.key, "_filter"),
        className: _CwDataGrid.default.textField,
        value: this.props.filterValue,
        onChange: this.handleInputChange
      }), this.props.column.filterType === 'date' && _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_column_").concat(this.props.column.key, "_filter"),
        value: this.dateFilterValueExists() ? '(click to change)' : '',
        className: _CwDataGrid.default.dateFilterButton,
        rightIcon: this.props.column.triggerIcon,
        onClick: function onClick() {
          _this3.props.onDateFilterClick(_this3.props.column, _this3.props.filterValue);
        }
      }), this.props.column.filterType === 'time' && _react.default.createElement(_TimeFilter.default, {
        cwId: this.props.cwId,
        column: this.props.column,
        filterValue: this.props.filterValue,
        onFilterChange: this.props.onFilterChange
      }), this.props.column.filterType === 'fileSize' && _react.default.createElement(_FileSizeFilter.default, {
        cwId: this.props.cwId,
        column: this.props.column,
        filterValue: this.props.filterValue,
        onFilterChange: this.props.onFilterChange
      }), this.props.column.filterType === 'number' && _react.default.createElement(_NumberFilter.default, {
        cwId: this.props.cwId,
        column: this.props.column,
        filterValue: this.props.filterValue,
        onFilterChange: this.props.onFilterChange
      }), this.props.column.filterType === 'comboBox' && _react.default.createElement(_CwComboBox.default, {
        cwId: "".concat(this.props.cwId, "_column_").concat(this.props.column.key, "_filter"),
        items: this.props.column.filterItems,
        value: this.props.filterValue,
        onChange: this.props.onFilterChange,
        textChange: this.props.onComboBoxTextChange,
        triggerIcon: this.props.column.triggerIcon,
        filterOnPartialMatch: true
      }), this.props.column.filterType === 'multiSelect' && _react.default.createElement("div", {
        className: _CwDataGrid.default.multiSelectFilter
      }, _react.default.createElement(_CwMultiSelect.default, {
        cwId: "".concat(this.props.cwId, "_column_").concat(this.props.column.key, "_filter"),
        items: this.props.column.filterItems,
        value: this.props.filterValue,
        onChange: this.handleMultiSelectChange,
        triggerIcon: this.props.column.triggerIcon,
        closePillIcon: this.props.column.closePillIcon,
        selectAllText: "Select All",
        allPillText: "All",
        filterOnPartialMatch: true
      }), _react.default.createElement("div", {
        className: _CwDataGrid.default.multiSelectFilterValue
      }, multiSelectValue))), this.props.column.resizable && _react.default.createElement(_ColumnResizeBar.default, {
        columnKey: this.props.column.key,
        hoverOffset: this.props.resizeHoverOffset,
        setResizeMode: this.props.setResizeMode,
        hasFilterTypes: this.props.hasFilterTypes
      }));
    }
  }]);
  return ColumnHeader;
}(_react.default.Component);

ColumnHeader.propTypes = {
  cwId: _propTypes.default.string.isRequired,
  column: _propTypes.default.object.isRequired,
  clearFilterImage: _propTypes.default.string,
  filterValue: _propTypes.default.any,
  hasFilterTypes: _propTypes.default.bool,
  resizeHoverOffset: _propTypes.default.object,
  sortCol: _propTypes.default.string,
  sortReverse: _propTypes.default.bool,
  sortArrowImage: _propTypes.default.string,
  sortArrowImageReverse: _propTypes.default.string,
  connectDragSource: _propTypes.default.func.isRequired,
  onComboBoxTextChange: _propTypes.default.func,
  onDateFilterClick: _propTypes.default.func,
  onFilterChange: _propTypes.default.func,
  // eslint-disable-next-line
  setReorderMode: _propTypes.default.func,
  setResizeMode: _propTypes.default.func,
  setSortCol: _propTypes.default.func
};
ColumnHeader.defaultProps = {
  clearFilterImage: '',
  filterValue: null,
  hasFilterTypes: false,
  resizeHoverOffset: {},
  sortCol: '',
  sortReverse: false,
  sortArrowImage: '',
  sortArrowImageReverse: '',
  onComboBoxTextChange: function onComboBoxTextChange() {},
  onDateFilterClick: function onDateFilterClick() {},
  onFilterChange: function onFilterChange() {},
  setReorderMode: function setReorderMode() {},
  setResizeMode: function setResizeMode() {},
  setSortCol: function setSortCol() {}
};

var _default = (0, _reactDnd.DragSource)('ColumnHeader', dragSource, collect)(ColumnHeader);

exports.default = _default;